export const calculateAngle = (a, b, c) => {
    if (!a || !b || !c) return 0;

    // Calculate vector BA
    const ba = { x: a.x - b.x, y: a.y - b.y };
    // Calculate vector BC
    const bc = { x: c.x - b.x, y: c.y - b.y };

    // Calculate dot product and magnitudes
    const dotProduct = ba.x * bc.x + ba.y * bc.y;
    const magBA = Math.sqrt(ba.x * ba.x + ba.y * ba.y);
    const magBC = Math.sqrt(bc.x * bc.x + bc.y * bc.y);

    // Calculate angle in radians
    let radians = Math.acos(dotProduct / (magBA * magBC));

    // Convert to degrees
    let degrees = radians * (180 / Math.PI);

    return Math.round(degrees);
};

export const calculateDistance = (a, b) => {
    if (!a || !b) return 0;
    return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
};
